var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('design-preview',{key:_vm.templateId,attrs:{"isMine":false,"idTemplate":_vm.templateId},model:{value:(_vm.templateId),callback:function ($$v) {_vm.templateId=$$v},expression:"templateId"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }